/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import keyBy from 'lodash/keyBy';
import * as types from '../constants';

const INITIALSTATE = {
    list: [],
    filterOptions: [],
    availabilityMapData: {},
    is_multisized: true,
    changeCounter: 0,
};

const transformDetailedAvailabilityToMap = (list) => keyBy(list, 'id');

export default function availabilityReducers(state = INITIALSTATE, action) {
    const st = { ...state };

    switch (action.type) {
        case types.GET_DIVISION_INSTANCES_STARTED:
            st.is_loading = true;
            return st;
        case types.GET_DIVISION_INSTANCES:
            st.list = action.payload.grid;
            // st.filterOptions = uniq(action.payload.raw.map(mapAvailabilityToRange));
            st.availabilityMapData = transformDetailedAvailabilityToMap(
                action.payload.raw
            );
            st.changeCounter += 1;
            delete st.err;
            delete st.is_loading;
            return st;
        case types.GET_DIVISION_INSTANCES_ERROR:
            st.err = action.payload;
            delete st.is_loading;
            return st;
        case types.SET_DIVISIONS_MULTISIZED:
            st.is_multisized = action.payload;
            return st;
        default:
            return st;
    }
}
